import styled from '@emotion/styled';

type Props = { content: string };

const Title = styled.h1`
  text-align: center;
  font-size: 24px;
`;

export default function TitleComponent({ content }: Props) {
  return <Title>{content}</Title>;
}
